var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuEmblemRgb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 294.94 200.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #039;\n      }\n\n      .cls-3 {\n        fill: #fc0;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 294.95,
    height: 200.41
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.67,
    y: 5.67,
    width: 283.6,
    height: 189.07
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "141.53 46.86 147.51 42.5 153.5 46.86 151.22 39.8 157.3 35.44 149.8 35.44 147.51 28.29 145.22 35.44 137.73 35.44 143.8 39.8 141.53 46.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "110.56 55.19 116.54 50.82 122.52 55.19 120.25 48.12 126.32 43.76 118.83 43.76 116.54 36.6 114.25 43.76 106.76 43.76 112.83 48.12 110.56 55.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "93.88 59.31 91.59 66.47 84.1 66.47 90.18 70.83 87.9 77.9 93.88 73.53 99.87 77.9 97.59 70.83 103.66 66.47 96.18 66.47 93.88 59.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "85.57 104.46 91.55 108.83 89.28 101.76 95.35 97.4 87.86 97.4 85.57 90.24 83.28 97.41 75.78 97.4 81.86 101.76 79.59 108.83 85.57 104.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "96.18 128.42 93.88 121.26 91.59 128.43 84.1 128.42 90.18 132.79 87.9 139.85 93.88 135.47 99.87 139.85 97.59 132.79 103.66 128.42 96.18 128.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "118.88 151.12 116.59 143.97 114.3 151.13 106.8 151.12 112.88 155.49 110.61 162.55 116.59 158.19 122.57 162.55 120.3 155.49 126.37 151.12 118.88 151.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "149.81 159.35 147.52 152.19 145.23 159.36 137.73 159.35 143.81 163.72 141.53 170.78 147.52 166.41 153.5 170.78 151.22 163.72 157.3 159.35 149.81 159.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "180.74 151.12 178.45 143.97 176.15 151.13 168.67 151.12 174.74 155.49 172.46 162.55 178.45 158.19 184.43 162.55 182.15 155.49 188.23 151.12 180.74 151.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "203.45 128.42 201.15 121.26 198.86 128.43 191.37 128.42 197.45 132.79 195.17 139.85 201.15 135.47 207.14 139.85 204.86 132.79 210.93 128.42 203.45 128.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "219.16 97.31 211.67 97.31 209.37 90.15 207.08 97.32 199.59 97.31 205.67 101.68 203.39 108.74 209.37 104.36 215.36 108.74 213.08 101.68 219.16 97.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "195.17 77.8 201.15 73.44 207.14 77.8 204.86 70.74 210.93 66.38 203.45 66.38 201.15 59.22 198.86 66.39 191.37 66.38 197.45 70.74 195.17 77.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "178.53 36.61 176.25 43.77 168.75 43.76 174.82 48.13 172.55 55.19 178.54 50.82 184.52 55.19 182.25 48.13 188.32 43.76 180.82 43.76 178.53 36.61"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuEmblemRgb);
export default __webpack_public_path__ + "static/media/EU-emblem_RGB.7bd9511d9a1ddffc461fffdeb16c2cf4.svg";
export { ForwardRef as ReactComponent };